'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _watchAppNotifier = require('common/components/mixins/watch-app-notifier');

var _watchAppNotifier2 = _interopRequireDefault(_watchAppNotifier);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// In-app left side menu
var AppLeftMenu = _react2['default'].createClass({
    displayName: 'AppLeftMenu',


    mixins: [_watchAppNotifier2['default']],

    propTypes: {
        'siteCode': _react2['default'].PropTypes.string.isRequired, // S or F
        'pageSize': _react2['default'].PropTypes.number, // List size
        'searchBackend': _react2['default'].PropTypes.string, // Type of search backend to use
        'activeItemId': _react2['default'].PropTypes.string, // Menu item currently active
        'hasTeamFilter': _react2['default'].PropTypes.bool, // Whether the user can view all team docs
        'hasCompletedFilter': _react2['default'].PropTypes.bool, // Whether the completed filter is visible currently
        'emailAddress': _react2['default'].PropTypes.string.isRequired, // Email address for the current user
        'faxNumbers': _react2['default'].PropTypes.array, // List of fax numbers
        'name': _react2['default'].PropTypes.string // Name of the user
    },

    FILTERS: {
        'documentsallteam': 'all_team',
        'documentsoutforsignature': 'out_for_signature',
        'documentsawaiting': 'awaiting_my_signature',
        'documentscompleted': 'completed',
        'documentsdeclined': 'declined',
        'documentstemplates': 'template',
        'documentstemplatelinks': 'template_link',
        'documentsdrafts': 'draft',
        'documentssent': 'sent',
        'documentsreceived': 'received'
    },

    getInitialState: function getInitialState() {

        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
        var defaultItemId = isHf ? 'sendfax' : 'signdocs';
        var activeItemId = this.props.activeItemId || defaultItemId;

        // Convert filters to section item ref
        for (var k in this.FILTERS) {
            if (this.FILTERS[k] === activeItemId) {
                activeItemId = k;
                break;
            }
        }

        return {
            'activeItemId': activeItemId,
            faxLines: this.props.app.user.getFaxLines()
        };
    },
    componentDidMount: function componentDidMount() {

        var root = $(_reactDom2['default'].findDOMNode(this));
        var self = this;

        $('.m-app-leftmenu--section--title > a, .m-app-leftmenu--section--item > a', root).click(function (evt) {

            if (evt.target.tagName === 'A' || evt.target.parentNode.tagName === 'A') {
                return;
            }

            evt.preventDefault();

            var el = $(this);
            var itemId = el.attr('id');

            if (!itemId) {
                itemId = el.parent().attr('id');
            }

            self.setState({
                'activeItemId': itemId
            });
        });
    },
    getItemClassName: function getItemClassName(sectionName, isItem) {
        var s = 'm-app-leftmenu--section' + (isItem ? '--item' : '');
        if (sectionName === 'signdocs' && $.inArray(this.state.activeItemId, ['signjustme', 'signmeandothers', 'signjustothers']) >= 0 || sectionName === 'templates' && $.inArray(this.state.activeItemId, ['createtemplate', 'createtemplatelink', 'usetemplate', 'usetemplatelink']) >= 0 || sectionName === 'documents' && $.inArray(this.state.activeItemId, Object.keys(this.FILTERS)) >= 0) {
            s += ' is-expanded';
        } else if (this.state.activeItemId === sectionName) {
            s += ' is-active';
        }
        return s;
    },
    makeFilter: function makeFilter(id, label, noDot) {

        var params = ['filter=' + this.FILTERS[id]];
        if (this.props.searchBackend) {
            params.push('search_backend=' + this.props.searchBackend);
        }
        if (this.props.pageSize) {
            params.push('page_size=' + this.props.pageSize);
        }

        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        var url = _hfReactHelper2['default'].urlHelper('home/manage?' + params.join('&'), site);

        var dotImg;
        if (noDot !== true) {
            dotImg = _react2['default'].createElement('img', { src: _hfReactHelper2['default'].imgHelper('v2/layout/filters/' + id.replace('documents', '') + '@2x.png') });
        }

        return _react2['default'].createElement(
            'div',
            { id: id, className: this.getItemClassName(id, true) },
            _react2['default'].createElement(
                'span',
                { className: 'm-app-leftmenu--section--item--dot' + (noDot === true ? ' is-blank' : '') },
                dotImg
            ),
            _react2['default'].createElement(
                'a',
                { href: url },
                label
            )
        );
    },
    render: function render() {

        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
        var templates;
        var sendFax;
        var recvFax;
        var getFreePages;
        var signDocs;
        var allTeamDocsFilter;
        var completedFilter;
        var faxNumbers;
        var siteSpecificFilters;

        var meAndOthersParams = 'me=1';

        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        var teamUrl = _hfReactHelper2['default'].urlHelper('home/team', site);
        var createTemplateUrl = _hfReactHelper2['default'].urlHelper('home/createTemplate', site);
        var createLinkUrl = _hfReactHelper2['default'].urlHelper('home/createReusableLink', site);
        var sendFaxUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
        var recvFaxUrl = _hfReactHelper2['default'].urlHelper('home/upgrade', site);
        var freePagesUrl = _hfReactHelper2['default'].urlHelper('account/gettingStarted', site);
        var useTemplateUrl = _hfReactHelper2['default'].urlHelper('home/manage?filter=template', site);
        var useLinkUrl = _hfReactHelper2['default'].urlHelper('home/manage?filter=template_link', site);
        var justMeUrl = _hfReactHelper2['default'].urlHelper('sign', site);
        var meAndOthersUrl = _hfReactHelper2['default'].urlHelper('home/request?' + meAndOthersParams, site);
        var justOthersUrl = _hfReactHelper2['default'].urlHelper('home/request', site);
        var signUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
        var templateUrl = _hfReactHelper2['default'].urlHelper('home/createReusableDocs', site);
        var docsUrl = _hfReactHelper2['default'].urlHelper('home/manage', site);
        var integrationsUrl = _hfReactHelper2['default'].urlHelper('home/myAccount?current_tab=integrations', site);
        var documentsName = 'Documents';

        if (isHf) {

            documentsName = 'Faxes';

            sendFax = _react2['default'].createElement(
                'div',
                { id: 'sendfax', className: this.getItemClassName('sendfax') },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--section--title' },
                    _react2['default'].createElement(
                        'a',
                        { href: sendFaxUrl },
                        _react2['default'].createElement(
                            'span',
                            null,
                            'Send a fax'
                        )
                    )
                )
            );

            if (this.props.showUpgradeButton == true) {
                recvFax = _react2['default'].createElement(
                    'div',
                    { id: 'recvfax', className: this.getItemClassName('recvfax') },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-leftmenu--section--title' },
                        _react2['default'].createElement(
                            'a',
                            { href: recvFaxUrl },
                            _react2['default'].createElement(
                                'span',
                                null,
                                'Receive faxes'
                            )
                        )
                    )
                );
            } else {
                recvFax = '';
            }

            signDocs = _react2['default'].createElement(
                'div',
                { id: 'signdocs', className: this.getItemClassName('signdocs') },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--section--title' },
                    _react2['default'].createElement(
                        'a',
                        { href: justOthersUrl },
                        _react2['default'].createElement(
                            'span',
                            null,
                            'Sign documents'
                        )
                    )
                )
            );

            getFreePages = _react2['default'].createElement(
                'div',
                { id: 'getfreepages', className: 'l-margin-t-50 ' + this.getItemClassName('getfreepages') },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--section--title' },
                    _react2['default'].createElement(
                        'a',
                        { href: freePagesUrl },
                        _react2['default'].createElement(
                            'span',
                            null,
                            'Get free pages'
                        )
                    )
                )
            );
            if (this.props.hasTeamFilter) {
                allTeamDocsFilter = this.makeFilter('documentsallteam', 'All team faxes');
            }
            siteSpecificFilters = _react2['default'].createElement(
                'div',
                { className: 'm-app-leftmenu--section--items' },
                allTeamDocsFilter,
                this.makeFilter('documentssent', 'Sent'),
                this.makeFilter('documentsreceived', 'Received'),
                this.makeFilter('documentsdrafts', 'Drafts')
            );

            if (this.state.faxLines && this.state.faxLines.length > 0) {

                var numbers = this.state.faxLines.map(function (faxLine, index) {
                    return _react2['default'].createElement(
                        'div',
                        { key: index, className: 'm-app-leftmenu--fax-numbers--list--item' },
                        faxLine.number
                    );
                });

                var listClasses = (0, _classnames2['default'])({
                    'm-app-leftmenu--fax-numbers--list': true,
                    'is-scrollable': this.state.faxLines.length > 12
                });

                faxNumbers = _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--fax-numbers' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-app-leftmenu--fax-numbers--title' },
                        this.state.faxLines.length > 1 ? 'YOUR FAX NUMBERS' : 'YOUR FAX NUMBER'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: listClasses },
                        numbers
                    )
                );
            }
        } else {

            signDocs = _react2['default'].createElement(
                'div',
                { id: 'signdocs', className: this.getItemClassName('signdocs') },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--section--title' },
                    _react2['default'].createElement(
                        'a',
                        { href: signUrl },
                        _react2['default'].createElement(
                            'span',
                            null,
                            'Sign documents'
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--section--items' },
                    _react2['default'].createElement(
                        'div',
                        { id: 'signjustme', className: this.getItemClassName('signjustme', true) },
                        _react2['default'].createElement(
                            'a',
                            { href: justMeUrl },
                            'Just me'
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { id: 'signmeandothers', className: this.getItemClassName('signmeandothers', true) },
                        _react2['default'].createElement(
                            'a',
                            { href: meAndOthersUrl },
                            'Me & others'
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { id: 'signjustothers', className: this.getItemClassName('signjustothers', true) },
                        _react2['default'].createElement(
                            'a',
                            { href: justOthersUrl },
                            'Just others'
                        )
                    )
                )
            );

            templates = _react2['default'].createElement(
                'div',
                { id: 'templates', className: this.getItemClassName('templates') },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--section--title m-app-leftmenu--templates' },
                    _react2['default'].createElement(
                        'a',
                        { href: templateUrl },
                        _react2['default'].createElement(
                            'span',
                            null,
                            'Templates'
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--section--items' },
                    _react2['default'].createElement(
                        'div',
                        { id: 'createtemplate', className: this.getItemClassName('createtemplate', true) },
                        _react2['default'].createElement(
                            'a',
                            { href: createTemplateUrl },
                            'Create template'
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { id: 'createtemplatelink', className: this.getItemClassName('createtemplatelink', true) },
                        _react2['default'].createElement(
                            'a',
                            { href: createLinkUrl },
                            'Create link'
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { id: 'usetemplate', className: this.getItemClassName('usetemplate', true) },
                        _react2['default'].createElement(
                            'a',
                            { href: useTemplateUrl },
                            'Use template'
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { id: 'usetemplatelink', className: this.getItemClassName('usetemplatelink', true) },
                        _react2['default'].createElement(
                            'a',
                            { href: useLinkUrl },
                            'Use link'
                        )
                    )
                )
            );

            if (this.props.hasTeamFilter) {
                allTeamDocsFilter = this.makeFilter('documentsallteam', 'All team documents');
            }
            if (this.props.hasCompletedFilter) {
                completedFilter = this.makeFilter('documentscompleted', 'Completed');
            }
            siteSpecificFilters = _react2['default'].createElement(
                'div',
                { className: 'm-app-leftmenu--section--items' },
                allTeamDocsFilter,
                this.makeFilter('documentsoutforsignature', 'Out for signature'),
                this.makeFilter('documentsawaiting', 'Awaiting my signature'),
                completedFilter,
                this.makeFilter('documentsdeclined', 'Declined'),
                this.makeFilter('documentstemplates', 'Templates'),
                this.makeFilter('documentstemplatelinks', 'Template links'),
                this.makeFilter('documentsdrafts', 'Draft')
            );
        }

        var res = _react2['default'].createElement(
            'div',
            { className: 'm-app-leftmenu' },
            sendFax,
            recvFax,
            signDocs,
            templates,
            _react2['default'].createElement(
                'div',
                { id: 'documents', className: this.getItemClassName('documents') },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--section--title m-app-leftmenu--documents' },
                    _react2['default'].createElement(
                        'a',
                        { href: docsUrl },
                        _react2['default'].createElement(
                            'span',
                            null,
                            documentsName
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--section--items' },
                    siteSpecificFilters
                )
            ),
            _react2['default'].createElement(
                'div',
                { id: 'manageteam', className: this.getItemClassName('manageteam') },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--section--title m-app-leftmenu--team' },
                    _react2['default'].createElement(
                        'a',
                        { href: teamUrl },
                        _react2['default'].createElement(
                            'span',
                            null,
                            'Team'
                        )
                    )
                )
            ),
            _react2['default'].createElement(
                'div',
                { id: 'manage_integrations', className: this.getItemClassName('manage_integrations') },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-app-leftmenu--section--title m-app-leftmenu--integrations' },
                    _react2['default'].createElement(
                        'a',
                        { href: integrationsUrl },
                        _react2['default'].createElement(
                            'span',
                            null,
                            'Integrations'
                        )
                    )
                )
            ),
            getFreePages,
            faxNumbers
        );

        return res;
    }
});

module.exports = AppLeftMenu;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/sidebar/index.jsx
 ** module id = 834
 ** module chunks = 0 1
 **/